__turbopack_context__.v({
  "accordionWrap": "FaqSection-module__9pWyaG__accordionWrap",
  "faqSection": "FaqSection-module__9pWyaG__faqSection",
  "loadMoreBtn": "FaqSection-module__9pWyaG__loadMoreBtn",
  "loadMoreWrap": "FaqSection-module__9pWyaG__loadMoreWrap",
  "title": "FaqSection-module__9pWyaG__title",
});
